module.exports = __webpack_public_path__ + "static/media/icon-power.9d916206.svg";